import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'
import {Dialog} from '@primer/react'

export function CheckTagNameDialog({
  isOpen,
  onDismiss,
  onConfirm,
}: {
  isOpen: boolean
  onDismiss: () => void
  onConfirm: () => void
}) {
  const {isBrowser} = useRuntimeEnvironment()

  if (!isBrowser || !isOpen) return null

  return (
    <Dialog
      title="Create branch"
      onClose={onDismiss}
      width="large"
      footerButtons={[
        {content: 'Cancel', onClick: onDismiss},
        {buttonType: 'danger', content: 'Create', onClick: onConfirm},
      ]}
    >
      <span>
        A tag already exists with the provided branch name. Many Git commands accept both tag and branch names, so
        creating this branch may cause unexpected behavior. Are you sure you want to create this branch?
      </span>
    </Dialog>
  )
}
